<div style="width: 1100px; height: 700px;" data-cy="ar-payment-distributions">
  <div class="spinnder-div" *ngIf="isLoading" data-cy="ar-payment-distributions-loading">
    <div class="spinner-holder" data-cy="ar-payment-distributions-spinner-holder">
      <mat-spinner data-cy="ar-payment-distributions-spinner"></mat-spinner>
    </div>
  </div>
  <div *ngIf="!isLoading" class="section"
       style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-payment-distributions-content">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-distributions-header">
      <div class="section-header-title" data-cy="ar-payment-distributions-title">
        Patient Credit Payment Distributions
      </div>
      <div style="flex: 1;" data-cy="ar-payment-distributions-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;overflow: auto;" data-cy="ar-payment-distributions-section-content">
      <!-- body of window-->
      <div style="display: flex; flex-direction: row" data-cy="ar-payment-distributions-info-container">
        <div style="flex: 1; margin-right: 20px;" data-cy="ar-payment-distributions-left-column">
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-amount-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-amount-label">Amount</div>
            <div style="flex-basis: 100px;" class="info-cell" data-cy="ar-payment-distributions-amount-value">{{ creditLedgerItem.Amount === null ? '&nbsp;' :
              creditLedgerItem.Amount | currency }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-posted-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-posted-label">Posted</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-posted-value">{{ creditLedgerItem.PostDate === null ? '&nbsp;' :
              creditLedgerItem.PostDate | date }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-type-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-type-label">Type</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-type-value">{{ returnPaymentType(creditPayment.enumARPayementTypeID ? creditPayment.enumARPayementTypeID : '') }}</div>
          </div>
          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-status-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-status-label">Status</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-status-value">{{ creditPayment ? creditPayment.PaymentStatus : '&nbsp;' }}</div>
          </div>
        </div>

        <div style="flex: 1" data-cy="ar-payment-distributions-right-column">

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-tdo-number-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-tdo-number-label">TDO Payment #</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-tdo-number-value">{{ creditPayment ? creditPayment.TDOPaymentReferenceNumber : '&nbsp;' }} </div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-reference-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-reference-label">Reference</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-reference-value">{{ creditLedgerItem.Reference ? creditLedgerItem.Reference : '&nbsp;' }}</div>
          </div>

          <div style="display: flex; flex-direction: row" class="cell-container" data-cy="ar-payment-distributions-description-container">
            <div style="flex-basis: 120px" data-cy="ar-payment-distributions-description-label">Description</div>
            <div style="flex:1" class="info-cell" data-cy="ar-payment-distributions-description-value">{{ creditLedgerItem.Description ? creditLedgerItem.Description : '&nbsp;' }}</div>
          </div>

        </div>
      </div>

      <div style="font-weight: bold; padding-top: 10px" data-cy="ar-payment-distributions-list-header">Payment Distributions</div>

      <div style="border: solid 1px var(--tdo-purple-light); height: 100%; width:100%" data-cy="ar-payment-distributions-list-container">
        <span *ngIf="!this.paymentDistributions.length" data-cy="ar-payment-distributions-no-distributions">No payment distributions recorded.</span>
        <tdo-table *ngIf="this.paymentDistributions.length>0" [dataSource]="this.paymentDistributions"
                   cypressControlIdentifier="payment-distributions-results" [isMultiSelection]="false" [isUsePaginator]="false"
                   [isSearchable]="false" style="max-height: 250px;" data-cy="ar-payment-distributions-table">
          <tdo-table-column [displayName]="creditLedgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypePatient? 'Pat. Estimate':'Ins. Estimate'" propertyName="Estimate" isSortable="false" [rowTemplate]="estimateAmount" data-cy="ar-payment-distributions-col-estimate">
            <ng-template #estimateAmount let-row>
              <div *ngIf="creditLedgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypePatient" data-cy="ar-payment-distributions-patient-estimate">{{ row.model.PatientEstimateAmount | currency }}</div>
              <div *ngIf="creditLedgerItem.enumARLedgerItemOriginTypeID == enumARLedgerItemOriginTypeInsurance" data-cy="ar-payment-distributions-insurance-estimate">{{ row.model.InsuranceEstimateAmount | currency }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Paid" propertyName="Amount" isSortable="false" [rowTemplate]="paymentAmount" data-cy="ar-payment-distributions-col-paid">
            <ng-template #paymentAmount let-row>
              <div *ngIf="row.Amount || row.Amount === 0" data-cy="ar-payment-distributions-amount-paid">{{ row.Amount | currency }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Date" propertyName="PostDate" isSortable="false" [rowTemplate]="date" data-cy="ar-payment-distributions-col-date">
            <ng-template #date let-row>
              <div *ngIf="row.model.PostDate" data-cy="ar-payment-distributions-date">{{ row.model.PostDate | date }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Code" propertyName="Code" isSortable="false" [rowTemplate]="code" data-cy="ar-payment-distributions-col-code">
            <ng-template #code let-row>
              <div *ngIf="row.model.Code" data-cy="ar-payment-distributions-code">{{ row.model.Code }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Description" propertyName="Description" isSortable="false"
                            [rowTemplate]="description" data-cy="ar-payment-distributions-col-description">
            <ng-template #description let-row>
              <div *ngIf="row.model.Description" data-cy="ar-payment-distributions-description">{{ row.model.Description }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Type" propertyName="Type" isSortable="false" [rowTemplate]="type" data-cy="ar-payment-distributions-col-type">
            <ng-template #type let-row>
              <div *ngIf="row.model.Type" data-cy="ar-payment-distributions-type-value">{{ row.model.Type }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Status" propertyName="Status" isSortable="false" [rowTemplate]="status" data-cy="ar-payment-distributions-col-status">
            <ng-template #status let-row>
              <div *ngIf="row.model.Status" data-cy="ar-payment-distributions-status-value">{{ row.model.Status }}</div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>

    </div>
    <!--  FOOTER-->
    <div class="section-footer"
         style="flex-basis: 60px; padding-top: 10px; padding-right: 10px;flex-direction:row-reverse" data-cy="ar-payment-distributions-footer">
      <button data-cy="payment-details-close-btn" (click)="close()" class="tdo-button tdo-close"
              style="margin-right: 10px;">Close</button>
    </div>
  </div>
</div>
